module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@2x-00810275392687db51347762752ccad4.png";